import { Divider, FLagWithText, Group, Skeleton, Text } from "components/common"
import { IconText, Separator, TitleDescription } from "components/custom"
import { CLIENT_DETAIL_PATH } from "constants/app-paths"
import UserProfileSummary from "features/shared/components/userProfileSummary"
import { t } from "i18next"
import { Link } from "react-router-dom"
import { joinBytItems, localisedValue } from "utils"
import theme from "utils/themeVars"

function AddReviewClientStaffHeader({ client, isLoading, showClientType = false }) {
  const clientId = client?.id
  const clientName =
    localisedValue({ object: client, key: "name" }) || localisedValue({ object: client, key: "clientName" })
  const staffName = localisedValue({ object: client?.User, key: "name" })
  const staffDesignation = localisedValue({ object: client?.User?.UserDesignation, key: "short" })
  const staffCity = localisedValue({ object: client?.User?.City, key: "name" })
  const clientCity = localisedValue({ object: client?.City, key: "name" })
  const clientCountry = client?.Country || client?.clientCountry
  const isIndividualClientType = client?.ClientType?.name === "Individual"
  const isCompanyClientType = client?.ClientType?.name === "Company"
  const clientType = isIndividualClientType
    ? { icon: "MdPersonOutline", title: localisedValue({ object: client?.ClientRating, key: "name" }) }
    : isCompanyClientType
      ? { icon: "RiTeamFill", title: localisedValue({ object: client?.ClientSubType, key: "name" }) }
      : null //

  if (isLoading) {
    return (
      <Group template="1fr auto 1fr" gap="0 16px" style={{ alignItems: "center" }}>
        <Group gap="6px" template="1fr">
          <Text className="fs-12 gray600">{t("Client")}</Text>
          <Skeleton height={20} width="80%" active />
          <Skeleton height={14} width="60%" active />
        </Group>
        <Divider type="vertical" style={{ borderColor: theme["gray-300"], marginInline: 0, height: "100%" }} />
        <Group gap="6px" template="1fr">
          <Text className="fs-12 gray600">{t("Staff")}</Text>
          <Skeleton height={20} width="75%" active />
          <Skeleton height={14} width="50%" active />
        </Group>
      </Group>
    )
  }

  return (
    <Group template="1fr auto 1fr" gap="0 16px" style={{ alignItems: "center" }}>
      <Group gap="4px" template="1fr">
        <Text className="fs-12 gray600">{t("Client")}</Text>
        {clientId ? (
          <TitleDescription
            title={
              <Link
                to={CLIENT_DETAIL_PATH.replace(":clientId", clientId)}
                className="text-link"
                style={{ color: theme["primary-color"], fontWeight: 200 }}
              >
                <FLagWithText
                  title={localisedValue({ object: clientCountry, key: "name" })}
                  countryCode={clientCountry?.locCode}
                  infoText={clientName || "—"}
                />
              </Link>
            }
            description={joinBytItems(
              [
                clientId,
                showClientType ? (
                  <IconText
                    icon={clientType?.icon}
                    title={clientType?.title}
                    titleProps={{ style: { color: theme["gray800"] } }}
                  />
                ) : (
                  clientCity
                ),
              ],
              <Separator />
            )}
          />
        ) : (
          <Text style={{ color: theme["primary-color"] }}>{clientName || "—"}</Text>
        )}
      </Group>

      <Divider type="vertical" style={{ borderColor: theme["gray-300"], marginInline: 0, height: "100%" }} />

      <Group gap="4px" template="1fr">
        <Text className="fs-12 gray600">{t("Staff")}</Text>
        <TitleDescription
          title={
            <>
              {" "}
              {staffName || "—"}&nbsp;
              {client?.User?.userId && <UserProfileSummary staffId={client?.User?.userId} />}
            </>
          }
          description={joinBytItems([staffDesignation, staffCity], <Separator />)}
        />
      </Group>
    </Group>
  )
}

export default AddReviewClientStaffHeader
